import { ProcessActivityStatus, ProcessTaskStatus, StepStatus } from '@common/enums';
import { never } from '@common/utils/never';

export function mapProcessActivityStatusToStepStatus(processActivityStatus: ProcessActivityStatus): StepStatus {
    switch (processActivityStatus) {
        case ProcessActivityStatus.cancelled:
            return StepStatus.obsolete;
        case ProcessActivityStatus.complete:
            return StepStatus.finished;
        case ProcessActivityStatus.draft:
            return StepStatus.inProgress;
        default:
            return never(processActivityStatus);
    }
}

export function mapProcessTaskStatusToStepStatus(processTaskStatus: ProcessTaskStatus): StepStatus {
    switch (processTaskStatus) {
        case ProcessTaskStatus.cancelled:
            return StepStatus.obsolete;
        case ProcessTaskStatus.closed:
            return StepStatus.finished;
        case ProcessTaskStatus.inProgress:
            return StepStatus.inProgress;
        case ProcessTaskStatus.open:
            return StepStatus.available;
        default:
            return never(processTaskStatus);
    }
}

export function mapProcessWorkflowStepStatusToActivityStatus(stepStatus: StepStatus): ProcessActivityStatus {
    switch (stepStatus) {
        case StepStatus.finished:
            return ProcessActivityStatus.complete;
        case StepStatus.cancelled:
            return ProcessActivityStatus.cancelled;
        case StepStatus.available:
        case StepStatus.failed:
        case StepStatus.inProgress:
        case StepStatus.obsolete:
        case StepStatus.scheduled:
            return ProcessActivityStatus.draft;
        default:
            return never(stepStatus);
    }
}

export function mapProcessWorkflowStepStatusToTaskStatus(stepStatus: StepStatus): ProcessTaskStatus {
    switch (stepStatus) {
        case StepStatus.available:
        case StepStatus.scheduled:
            return ProcessTaskStatus.open;
        case StepStatus.cancelled:
            return ProcessTaskStatus.cancelled;
        case StepStatus.finished:
            return ProcessTaskStatus.closed;
        case StepStatus.inProgress:
            return ProcessTaskStatus.inProgress;
        case StepStatus.failed:
        case StepStatus.obsolete:
            return ProcessTaskStatus.cancelled;
        default:
            return never(stepStatus);
    }
}
